'use es6';

import { createContext } from 'react';
const FavoriteChangeContext = /*#__PURE__*/createContext({
  showUnfavoriteedMsg: false
});
export default FavoriteChangeContext;